import { useSettings } from "@/context/SettingsContext";

export const translations = {
    en: {
        settings: "Settings",
        photos: "Photos",
        clock: "Clock",
        other: "Other",
        language: "Language",
        english: "English",
        vietnamese: "Vietnamese",
        github: "GitHub Repository",
        photoSource: "Photo source",
        picsum: "Picsum (random photos)",
        bing: "Bing Image of the Day",
        local: "Local photos",
        immich: "Immich",
        managePhotos: "Manage Photos",
        serverSettings: "Server Settings",
        selectPhotosAlbums: "Select Photos/Albums",
        imageChangeInterval: "Image change interval",
        minute: "minute",
        minutes: "minutes",
        keepScreenOn: "Keep screen on",
        disabled: "Disabled",
        alwaysOn: "Always on",
        transitionEffect: "Transition effect",
        fade: "Fade",
        blur: "Blur",
        slideHorizontal: "Slide (Horizontal)",
        slideVertical: "Slide (Vertical)",
        zoomOut: "Zoom Out",
        kenBurns: "Ken Burns",
        wallpaperPosition: "Wallpaper position",
        fill: "Fill",
        fit: "Fit",
        loading: "Loading...",
        visible: "Visible",
        _24h: "24 Hour Format",
        bgBlur: "Background Blur",
        font: "Font",
        size: "Size",
        movement: "Movement",
        continuous: "Continuous (DVD logo bounce)",
        interval: "Interval",
        static: "Static",
        resetPosition: "Reset Position",
        clockPositionReset: "Clock position reset.",
        tipStatic: "Tip: Drag the clock to reposition it when in Static mode.",
    },
    vi: {
        settings: "Cài đặt",
        photos: "Ảnh",
        clock: "Đồng hồ",
        other: "Khác",
        language: "Ngôn ngữ",
        english: "Tiếng Anh",
        vietnamese: "Tiếng Việt",
        github: "GitHub",
        photoSource: "Nguồn ảnh",
        picsum: "Picsum (ảnh ngẫu nhiên)",
        bing: "Hình nền Bing theo ngày",
        local: "Ảnh trên máy",
        immich: "Immich",
        managePhotos: "Quản lý ảnh",
        serverSettings: "Cài đặt máy chủ",
        selectPhotosAlbums: "Chọn Ảnh/Album",
        imageChangeInterval: "Khoảng thời gian đổi ảnh",
        minute: "phút",
        minutes: "phút",
        keepScreenOn: "Giữ màn hình luôn bật",
        disabled: "Tắt",
        alwaysOn: "Luôn bật",
        transitionEffect: "Hiệu ứng chuyển cảnh",
        fade: "Mờ dần",
        blur: "Làm mờ",
        slideHorizontal: "Trượt (Ngang)",
        slideVertical: "Trượt (Dọc)",
        zoomOut: "Thu nhỏ",
        kenBurns: "Ken Burns",
        wallpaperPosition: "Vị trí hình nền",
        fill: "Lấp đầy",
        fit: "Vừa vặn",
        loading: "Đang tải...",
        visible: "Hiển thị",
        _24h: "Định dạng 24 giờ",
        bgBlur: "Làm mờ nền",
        font: "Phông chữ",
        size: "Kích thước",
        movement: "Chuyển động",
        continuous: "Liên tục (DVD bounce)",
        interval: "Theo khoảng thời gian",
        static: "Cố định",
        resetPosition: "Đặt lại vị trí",
        clockPositionReset: "Đã đặt lại vị trí đồng hồ.",
        tipStatic: "Mẹo: Kéo đồng hồ để thay đổi vị trí khi ở chế độ Cố định.",
    },
};

export type TranslationKey = keyof typeof translations.en;

export const useTranslation = () => {
    const { generalSettings } = useSettings();
    const lang = generalSettings.language;

    const t = (key: TranslationKey) => {
        return translations[lang][key] || translations.en[key] || key;
    };

    return { t, lang };
};
